<!--
 * @Author: Lemon C
 * @Date: 2024-04-29 17:00:14
 * @LastEditTime: 2024-12-16 11:42:43
-->
<template>
    <div class="sup-docs-request-header">
        <span class="header-title">请求头</span>
        <div class="docs-el-table-box">
            <el-table :data="public_params" :tree-props="eltable_eltree_props" empty-text="无" row-key="id">
                <el-table-column label="基本" width="240" prop="name"> </el-table-column>
                <el-table-column prop="description"> </el-table-column>
            </el-table>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    docs_api_data: Object,
});

const eltable_eltree_props = ref({ children: 'subApiParams', hasChildren: 'hasChildren' });

const public_params = computed(() => {
    let paramList = [
        { name: 'HTTP URL', id: 2001, description: props.docs_api_data.route },
        { name: 'HTTP Method', id: 2002, description: props.docs_api_data.httpMethod },
    ];
    if (props.docs_api_data.publicInputParams) paramList.push(...props.docs_api_data.publicInputParams);
    return paramList;
});
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-docs-request-header {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: left;

    .header-title {
        position: relative;
        margin-bottom: 18px;
        height: 29px;
        font-weight: 600;
        font-size: 20px;
        color: var(--color-main-text-primary);
        line-height: 29px;
    }

    :deep(.docs-el-table-box) {
        .el-table {
            .el-table__header-wrapper {
                .el-table__cell {
                    font-weight: bold;
                    font-size: 16px;
                    color: var(--color-main-text-primary);
                    line-height: 24px;
                    background-color: var(--color-main-doc-eltree-cell-bg);
                    border-top: 1px solid var(--color-main-border-eltree-gray) !important;
                    border-bottom: 1px solid var(--color-main-border-eltree-gray) !important;
                }
            }

            .el-table__body-wrapper {
                .el-table__row {
                    .el-table__cell {
                        font-weight: 500;
                        font-size: 14px;
                        color: var(--color-main-text-secondary);
                        line-height: 20px;
                        border-bottom: 1px solid var(--color-main-border-eltree-gray) !important;

                        &:nth-child(1) {
                            color: var(--color-main-text-primary);
                        }
                    }
                }
            }

            &::before {
                background-color: var(--color-main-tree-before-bg) !important;
            }
        }
    }
}
</style>
